import React, { Component } from "react";
import "./Inventory.css";
import SuccessSnackbar from "../../MaterialComponents/Snackbars/SnackbarSucces";
import Paper from "@material-ui/core/Paper";
import SwipeableList from "../SwipeableList/SwipeableList";
import SwipeableListItem from "../SwipeableListItem/SwipeableListItem";
import displayDate from "../../../Utilities/displayDate";
import orderList from "../../../Utilities/orderList";
import formattedDate from "../../../Utilities/formattedDate";
import formattedTime from "../../../Utilities/formattedTime";
import { store } from "../../../Store/store";
import ListFunctions from "../ListFunctions/ListFunctions";
import categorizeList from "../../../Utilities/categorizeList";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "react-bootstrap";

let langData = require("../../../Data/language.json");

export default class Inventory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateDialog: false,
      currentItem: {},
    };
  }

  componentDidMount() {
    let currentOrder = store.getState().firebase.listOrder;
    if (currentOrder !== "" && currentOrder !== undefined) {
      orderList(this.props.currentInventory, currentOrder, "inventory");
    }
  }

  componentWillUnmount() {
    categorizeList("all", "inventory");
  }

  handleDateOpen = (curItem) => {
    this.setState({ dateDialog: true, currentItem: curItem });
  };

  handleDateClose = () => {
    this.setState({ dateDialog: false });
  };

  render() {
    let content = [];
    const { currentInventory } = this.props;
    let filterValue = this.props.filter;

    this.addItemTolist = (key) => {
      let amountSymbol = null;
      if (currentInventory[key].amount <= 20) {
        amountSymbol = (
          <img
            src={require("../../../Images/Icons/lowAmount.svg")}
            alt="amountIcon"
            className="amountIcon"
          ></img>
        );
      }
      let manualSymbol = null;
      let ean = currentInventory[key].EANcode.toString();
      if (ean.length === 10) {
        manualSymbol = (
          <img
            src={require("../../../Images/Icons/manualIcon.svg")}
            alt="manualIcon"
            style={{ marginLeft: "4px", width: "12px", height: "12px" }}
            className="manualIcon"
          ></img>
        );
      }

      var climateImg = null;
      if (currentInventory[key].carbon_fp !== undefined) {
        if (currentInventory[key].carbon_fp.climateScore !== undefined) {
          climateImg = (
            <img
              className="climateScore"
              src={require(`../../../Images/Icons/${
                "score" + currentInventory[key].carbon_fp.climateScore + ".svg"
              }`)}
              alt="climateScore"
            />
          );
        } else {
          climateImg = (
            <img
              className="climateScore"
              src={require("../../../Images/Icons/scoreNan.svg")}
              alt="climateScore"
            />
          );
        }
      } else {
        climateImg = (
          <img
            className="climateScore"
            src={require("../../../Images/Icons/scoreNan.svg")}
            alt="climateScore"
          />
        );
      }

      content.push(
        <SwipeableListItem
          item={currentInventory[key]}
          expanded={false}
          id={currentInventory[key].EANcode}
          qty={currentInventory[key].quantity}
          amount={currentInventory[key].amount}
          key={currentInventory[key].EANcode}
          onEditInventoryItem={(newItem) =>
            this.props.onEditInventoryItem(currentInventory[key], newItem)
          }
          onEditItemSlider={(amount) =>
            this.props.onEditItemSlider(currentInventory[key], amount)
          }
          onSwipe={(removeAll) =>
            this.props.onDelete(currentInventory[key], "inventory", removeAll)
          }
          onItemScreen={() => this.props.onItemScreen(currentInventory[key])}
        >
          <div className="container col-5 listCell">
            {climateImg}
            {currentInventory[key].name}
            {manualSymbol}
          </div>
          <div
            className="container col-1 listCell"
            style={{ overflow: "visible" }}
          >
            {currentInventory[key].quantity}
            {amountSymbol}
          </div>
          <div
            className="container col-2 listDateInventory"
            onClick={() => {
              this.handleDateOpen(currentInventory[key]);
            }}
          >
            {displayDate(currentInventory[key].dates[0])}
          </div>
          <div className="container col-2 listCell d-none d-sm-block">
            {currentInventory[key].comment}
          </div>
          <div className="container col-2 listBtn">
            {" "}
            <SuccessSnackbar
              onAddTo={this.props.onAddTo}
              itemToAdd={currentInventory[key]}
              comesFrom="inventory"
              actionStatus="move"
            />
          </div>
        </SwipeableListItem>
      );
    };
    if (currentInventory !== undefined || currentInventory.length !== 0) {
      for (let key in currentInventory) {
        if (filterValue === "" || filterValue === undefined) {
          try {
            this.addItemTolist(key);
          } catch (error) {
            console.log(error);
          }
        } else {
          try {
            if (
              currentInventory[key].name.toLowerCase().includes(filterValue)
            ) {
              this.addItemTolist(key);
            }
          } catch (error) {
            console.log(error);
          }
        }
      }
    }

    return (
      <div className="row ">
        <Dialog
          onClose={() => this.handleDateClose()}
          aria-labelledby="invDialogTitle"
          open={this.state.dateDialog}
        >
          <div
            className="container-fluid invDialogBackBtnContainer"
            style={{ textAlign: "right" }}
          >
            <Button
              id="invDialogCloseBtn"
              onClick={() => this.handleDateClose()}
            >
              <img
                src={require("../../../Images/Icons/No.svg")}
                alt="backIcon"
              ></img>
            </Button>
          </div>
          <DialogTitle
            style={{
              textAlign: "center",
              paddingTop: "5px",
              paddingBottom: "5px",
            }}
            disableTypography={true}
            id="invDialogTitle"
          >
            {langData[this.props.language].dialogs.inventoryDates.title}
            <p id="invDialogArticle">
              {this.state.currentItem !== undefined
                ? this.state.currentItem.name
                : "undefined"}
            </p>
          </DialogTitle>
          <div className="container-fluid col-11 invDates">
            <div className="row">
              <div className="container-fluid col-6">
                <p className="invDateTitle">
                  {langData[this.props.language].dialogs.inventoryDates.date}
                </p>
              </div>
              <div className="container-fluid col-6">
                <p className="invDateTitle">
                  {langData[this.props.language].dialogs.inventoryDates.time}
                </p>
              </div>
            </div>
            <hr />
            {this.state.currentItem.dates !== undefined
              ? this.state.currentItem.dates
                  .reverse()
                  .map(function (name, index) {
                    let formatted_date = formattedDate(name);
                    let formatted_time = formattedTime(name);
                    let even = index % 2 === 0;
                    return (
                      <div
                        key={index}
                        style={
                          even
                            ? { backgroundColor: "#E2E2E2" }
                            : { backgroundColor: "white" }
                        }
                        className="row"
                      >
                        <div className="container-fluid inventoryDateWrapper col-6">
                          <p className="invDateText">{formatted_date}</p>
                        </div>
                        <div className="container-fluid inventoryDateWrapper col-6">
                          <p className="invDateText">{formatted_time}</p>
                        </div>
                      </div>
                    );
                  })
              : "undefined"}
          </div>
        </Dialog>
        <Paper
          className="container-fluid col-lg-10 col-md-10 col-sm-11 inventoryBody"
          elevation={6}
          square
        >
          <ListFunctions
            language={this.props.language}
            onSearch={this.props.onSearch}
            filter={this.props.filter}
            emptyFilter={this.props.emptyFilter}
          />
          <SwipeableList language={this.props.language}>
            {content}
          </SwipeableList>
        </Paper>
      </div>
    );
  }
}
